import * as base from "./base";
import * as derived from "./derived";

/**
 * PCB layout node selectors namespace
 *
 * Usage:
 * - pcbLayoutNodes.byUid('uid')(state) - Get node by UID
 * - pcbLayoutNodes.topLevelUids(state) - Get top-level node UIDs
 * - pcbLayoutNodes.componentsContainerUid(state) - Get Components container UID
 * - pcbLayoutNodes.isLockedByInheritance(uid)(state) - Check inherited lock
 * - pcbLayoutNodes.isPcbNodeSelected(uid)(state) - Check if node is selected
 */
export const pcbLayoutNodes = {
    ...base,
    ...derived,
} as const;

export type PcbLayoutNodesSelectors = typeof pcbLayoutNodes;
